import React from 'react'
import TextRow from '../Rows/TextRow'
import SwitchRow from '../Rows/SwitchRow'
import { Shadow } from '../../types/Shadow.types'
import { FormTabProps } from '../../types/FormTab.types'

const GsmConfigurationSection = ({ formState, handleChangeByShadow }: FormTabProps) => {
    const inputChanged = handleChangeByShadow(Shadow.Gsm);

    return (
        <>
            <SwitchRow
                label="Korzystanie z sieci GSM"
                caption="GSM_ENABLED"
                switchName={"gsm.GSM_ENABLED"}
                checked={formState.gsm.GSM_ENABLED}
                onChange={inputChanged}
            />

            <TextRow
                label="PIN"
                caption="Konfiguracja PIN"
                name="gsm.PIN"
                value={formState.gsm.PIN}
                onChange={inputChanged}
            />

            <TextRow
                label="APN"
                caption="Konfiguracja APN"
                name="gsm.APN"
                value={formState.gsm.APN}
                onChange={inputChanged}
            />

            <TextRow
                label="ACCN"
                caption="Konfiguracja ACCN"
                name="gsm.ACCN"
                value={formState.gsm.ACCN}
                onChange={inputChanged}
            />

        </>
    )
}

export default GsmConfigurationSection